import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import {App} from '@app/App';
import './app/index.css';
// AG Grid модули регистрируются лениво в @ui/lazy/LazyAgGrid при первом использовании.
// Раньше здесь был `import '@lib/ag-grid-setup'`, который тянул весь AG Grid (~1MB) в initial bundle.

// ECharts инициализация (echarts.use([...]) в @lib/echarts) должна выполниться ДО
// первого echarts.init(...) в любом компоненте. В production-bundle ECharts core
// может уехать в отдельный chunk и race с chart-компонентами → vg[l] is not a constructor.
// Явный side-effect import тут гарантирует, что use([...]) случится в entry chunk.
import '@lib/echarts';

import {bootstrapThemeMode} from '@lib/theme';
import {installChunkReloadHandler} from '@lib/chunk-reload';

// Ранняя установка класса `.dark` по сохранённому режиму — до первого рендера,
// чтобы не мигало светлой темой при тёмном выборе пользователя.
bootstrapThemeMode();

// Вкладка со старой версией после выкладки не находит свои чанки —
// перезагружаемся на свежую сборку вместо экрана ошибки.
installChunkReloadHandler();

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
